const DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
};

export default DIRECTIONS;
